import $ from 'cash-dom';
import {
    imgLoaded,
    drawImage,
    rotatePoint,
    positionToAngle,
    angleToPosition,
    anglePerPizza,
    getRewardIndex
} from './wheel-helper';

function LuckyWheel(woayId, opts, eventBus) {
    const {
        arrangement,
        rewards
    } = opts;
    const pizzaCount = arrangement.length;
    let randomNumber = 1;
    let stopAngle = 0;
    let totalAngle = 0;
    let oldAngle = false;
    let angle0 = 0;
    let firstSpin = true;
    let frameCount = 0;
    let fakeFrameCount = 0;
    let Wheel = false;
    let hasError = false;
    let spinning = false;
    let claimResp = {};
    let MIN_ANGLE = opts.MIN_ANGLE || 0.2;
    let DELTA_ANGLE = opts.DELTA_ANGLE || 0.2;
    let c, ctx, x, y, img;

    var CONSTANTS = Object.assign({}, {
        distance: 80,
        duration: 8000,
        speedFunction: t => 1 - --t * t * t * t, //'easeOutQuart',
        eps: 0.00005
    });

    initWheel(woayId, opts);

    function initWheel(woaySelector, opts) {
        const woayId = opts.Wheel.canvasId || "woay-wheel";
        Wheel = opts.Wheel;
        $(woaySelector).html(opts.Wheel.html);

        c = document.getElementById(woayId);
        if (!c) {
            c = $(woaySelector + " canvas")[0];
        }
        ctx = c.getContext("2d");
        x = c.width / 2;
        y = c.height / 2;

        img = new Image();
        img.src = opts.image.origin;
        if (!Wheel.vertical) {
            rotatePoint(ctx, x, y, -Math.PI / 2);
        }

        if (imgLoaded(img)) {
            drawImage(ctx, img, c);
        } else {
            img.onload = function () {
                drawImage(ctx, img, c);
            };
        }
    }

    function shouldStop(currentPosition, target, t) {
        if (t < 1 / 5) return false;
        // console.log("shoudStop", currentPosition, target);
        if (Math.abs(currentPosition - target) < 0.5) return true;
        // fix TH xoay ngược, 6.9999 ~ 7 == pizzaCount
        // randomNumer = 0
        if ((target == 0) & (Math.abs(currentPosition - pizzaCount) < 0.5))
            return true;
        return false;
    }

    function woayStart() {
        // TODO: KHÔNG THẤY chỗ nào set hasError
        if (hasError) {
            return window.reload();
        }
        if (stopAngle === false) {
            return iziToast.info({
                message: "Đang kiểm tra, vui lòng đợi"
            });
        }

        let {
            distance,
            duration,
            eps
        } = Object.assign({}, CONSTANTS);

        let start = performance.now();
        let lastTime = start;
        let func = CONSTANTS.speedFunction;

        distance = stopAngle - angle0;
        // console.log("new distance:", distance);
        spinning = true;
        firstSpin = false;
        window.requestAnimationFrame(frame);

        function frame() {
            frameCount++;
            let time = performance.now() - start;
            let t = time / duration;
            let frameTime = performance.now() - lastTime;
            lastTime = performance.now();
            // console.log('frameTime =======>', frameTime);
            if (frameTime > 50) {
                console.log('skip 1 frame');
                start += frameTime;
                window.requestAnimationFrame(frame);
                return;
            }
            let delta = func(t);
            let newAngle = angle0 + distance * delta;
            let angle = newAngle - totalAngle;
            totalAngle = newAngle;
            let currentPosition = angleToPosition(totalAngle, pizzaCount);
            // console.log({
            //     'time':  time,
            //     't': t,
            //     'angle': angle,
            //     'delta': delta,
            //     'totalAngle': totalAngle,
            //     'currentPosition': currentPosition
            // })
            if (
                (angle <= eps && shouldStop(currentPosition, randomNumber, t)) ||
                currentPosition < 0
            ) {
                // console.log("FrameCount", frameCount);
                if (currentPosition < 0) {
                    rotatePoint(ctx, x, y, oldAngle - stopAngle);
                    drawImage(ctx, img, c);
                }
                // console.log("before wheel-stop", {
                //     frameCount,
                //     fakeFrameCount,
                //     stopAngle,
                //     angle0
                // });
                frameCount = 0;
                fakeFrameCount = 0;
                stopAngle = 0;
                spinning = false;
                return eventBus.emit("wheel-stop", randomNumber);
            } else {
                rotatePoint(ctx, x, y, -angle);
                drawImage(ctx, img, c);
                oldAngle = totalAngle;
                window.requestAnimationFrame(frame);
            }
        }

        return "OK";
    }

    function passClaimResp(_claimResp) {
        claimResp = _claimResp;
    }

    function setupAnimation(index) {
        // console.log('setUpAnimation', { stopAngle })
        randomNumber = index;
        angle0 = totalAngle;
        let distance = CONSTANTS.distance;
        let endAngle = angle0 + distance;
        stopAngle = positionToAngle(index, pizzaCount);

        while (stopAngle < endAngle) {
            stopAngle += 2 * Math.PI;
        }

        // Random in 0.7 -> 0.90 of a pizza, not middle
        stopAngle += (MIN_ANGLE - 0.5 + Math.random() * DELTA_ANGLE) * anglePerPizza(pizzaCount);
    }

    function rollToSku(sku) {
        var item = rewards.find(x => x.sku === sku);
        if (!item) {
            eventBus.emit('cannotSpin');
            return;
        }
        const r = getRewardIndex(item, opts);
        setupAnimation(r);
        woayStart();
    }

    return {
        isSpinning() {
            return spinning;
        },
        isFirstSpin() {
            return firstSpin;
        },
        rollToSku,
        woayStart,
        setupAnimation,
        initWheel,
        passClaimResp
    };
}

export default LuckyWheel;